import { addDefinition } from '../classes/object-definition';
export function BeforeDeserialized() {
    // eslint-disable-next-line
    return function (target, key) {
        const definition = addDefinition(target.constructor);
        definition.beforeDeserialized = target[key];
    };
}
//# sourceMappingURL=before-deserialized.js.map